module.exports = __webpack_public_path__ + "static/media/result_fb_ja.d4583a3c.jpg";